import CustomList from "../../../core/components/core/Util/List/CustomList/CustomList";
import CustomListContainer from "../../../core/components/core/Util/List/CustomList/CustomListContainer";
import config from "../../../application/config/config";
import { loadData } from "../../../core/components/core/Util/List/CustomList/loadData";
import { useState, useMemo, useEffect } from "react";
import { useDispatch } from "react-redux";
import { getYears } from "./Util/helper";
import sleep from "sleep-promise";
import { chooseProfileFilter } from "../../helpers/chooseProfileFilter";

function List() {
  const profileFilter = chooseProfileFilter();
  const pathFrontEnd = "/governanceroom/files/";
  const paths = useMemo(
    () => ({
      pathAdd: pathFrontEnd + "add",
      pathEdit: pathFrontEnd + "edit",
      pathView: pathFrontEnd + "view",
      endpoint: `${config.endpoints.backend}governanceroom/files/getall`,
      endpointDelete: `${config.endpoints.backend}governanceroom/files/delete`,
      endpointStates: `${config.endpoints.backend}governanceroom/states/getall`,
      endpointCities: `${config.endpoints.backend}governanceroom/cities/getall`,
      endpointCategories: `${config.endpoints.backend}governanceroom/filecategories/getall`,
      endpointFileTypes: `${config.endpoints.backend}governanceroom/filetypes/getall`,
    }),
    [],
  );

  const dispatch = useDispatch();

  const yearsOptions = getYears({ start: 1920 }).map((year) => ({
    label: year,
    value: year,
  }));

  const [filterValues, setFilterValues] = useState({});

  const handleChange = async (element) => {
    const target = element["target"];
    let filters = { ...filterValues };
    if (target.name === "governance_room_file_category_id") {
      filters.governance_room_file_type_id = "";
    }
    if (target.name === "governance_room_geo_state_id") {
      filters.governance_room_city_id = "";
    }
    filters = { ...filters, [target["name"]]: target["value"] };
    setFilterValues(filters);
    await sleep(1000);
    dispatch({
      type: "UPDATE_SESSION",
      key: "custom_list_reload",
      value: new Date(),
    });
  };

  useEffect(() => {
    async function fetchArchives() {
      await sleep(500);
      dispatch({
        type: "UPDATE_SESSION",
        key: "custom_list_reload",
        value: new Date(),
      });
    }

    fetchArchives();
  }, [filterValues]);

  const filters = useMemo(
    () => ({
      validateOnChange: true,
      showGoBackButton: false,
      showSubmitButton: false,
      update_key: `${filterValues.governance_room_file_category_id}-${filterValues.governance_room_geo_state_id}-${filterValues.governance_room_file_type_id}-${filterValues.year}-${filterValues.status_archive}`,
      handleSubmit: loadData,
      fields: [
        {
          name: "year",
          type: "select",
          label: "Ano",
          validations: {
            required: false,
          },
          options: yearsOptions,
          handleChange,
          columnSize: 2,
        },
        {
          name: "governance_room_file_category_id",
          type: "select",
          label: "Categoria de arquivo",
          options: [],
          optionsEndpoint: {
            endpoint: paths.endpointCategories,
            label: "file_category",
            value: "id",
            params: {
              profileFilter,
            },
          },
          handleChange,
          validations: {
            required: false,
          },
          columnSize: 2,
        },
        {
          name: "governance_room_file_type_id",
          type: "select",
          label: "Tipo de arquivo",
          options: [],
          optionsEndpoint: {
            endpoint: paths.endpointFileTypes,
            label: "file_type",
            value: "id",
            params: {
              filter: {
                where: {
                  governance_room_category_id:
                    filterValues.governance_room_file_category_id,
                  ...profileFilter,
                  profileFilter,
                },
              },
            },
          },
          handleChange,
          validations: {
            required: false,
          },
          columnSize: 3,
        },
        {
          name: "governance_room_geo_state_id",
          type: "select",
          label: "Estado",
          options: [],
          optionsEndpoint: {
            endpoint: paths.endpointStates,
            label: "geografic_state_uf",
            value: "geografic_state_id",
          },
          validations: {
            required: false,
          },
          handleChange,
          columnSize: 1,
        },
        {
          name: "governance_room_city_id",
          type: "select",
          label: "Município",
          options: [],
          optionsEndpoint: {
            endpoint: paths.endpointCities,
            label: "city_name",
            value: "city_id",
            params: {
              filter: {
                where: {
                  geografic_state_id: filterValues.governance_room_geo_state_id,
                },
              },
            },
          },
          validations: {
            required: false,
          },
          handleChange,
          columnSize: 2,
        },
        {
          name: "status_archive",
          label: "Status",
          type: "select",
          options: [
            { label: "Aguardando", value: "WAITING" },
            { label: "Processando", value: "PROCESSING" },
            { label: "Finalizado", value: "DONE" },
            { label: "Erro", value: "ERROR" },
            { label: "Deletando", value: "DELETING" },
          ],
          handleChange,
          validations: {
            required: false,
          },
          columnSize: 2,
        },
      ],
      values: {
        governance_room_file_type_id: filterValues.governance_room_file_type_id,
        governance_room_file_category_id:
          filterValues.governance_room_file_category_id,
        governance_room_geo_state_id: filterValues.governance_room_geo_state_id,
        governance_room_city_id: filterValues.governance_room_city_id,
        status_archive: filterValues.status_archive,
        year: filterValues.year,
      },
    }),
    [paths, filterValues],
  );

  const list = useMemo(() => {
    let list = {
      labelTitle: "Upload de Arquivos",
      labelTitleButtonAdd: "Novo upload de arquivo",
      fieldsShowOnDelete: ["file_type", "year"],
      showPrintButtons: false,
      filter: {
        governance_room_file_type_id: filterValues.governance_room_file_type_id,
        governance_room_file_category_id:
          filterValues.governance_room_file_category_id,
        governance_room_geo_state_id: filterValues.governance_room_geo_state_id,
        governance_room_city_id: filterValues.governance_room_city_id,
        status_archive: filterValues.status_archive,
        year: filterValues.year,
        profileFilter,
      },
      canDelete: true,
      canEdit: false,
      formFilters: filters,
      columns: [
        {
          name: "reference_key",
          label: "Referência",
          width: "10%",
          sortable: true,
        },
        {
          name: "year",
          label: "Ano",
          width: "10%",
          sortable: true,
        },
        {
          name: "city_name",
          label: "Município",
          width: "10%",
          sortable: true,
        },
        {
          name: "file_category",
          label: "Categoria",
          width: "10%",
          sortable: true,
        },
        {
          name: "file_type",
          label: "Arquivo",
          width: "20%",
          sortable: true,
        },
        {
          name: "count_processed_lines",
          label: "Processamento %",
          width: "10%",
          sortable: true,
        },
        {
          name: "created_at",
          label: "Data do Upload",
          width: "10%",
          sortable: true,
        },
        {
          name: "status",
          label: "Status",
          width: "10%",
          sortable: true,
        },
      ],
    };
    list = { ...list, ...paths };

    return list;
  }, [filters, paths]);

  const content = useMemo(
    () => <CustomList list={{ ...list, ...paths }} />,
    [list, paths, filters],
  );

  const customListContainer = useMemo(
    () => (
      <CustomListContainer
        pathAdd={paths.pathAdd}
        labelTitle={list.labelTitle}
        labelTitleButtonAdd={list.labelTitleButtonAdd}
        content={content}
      />
    ),
    [content, paths, filters, list],
  );

  return <div>{customListContainer}</div>;
}
export default List;
